import * as d3 from 'd3';

export function onMouseOver(svg, event, item) {
	d3.select(svg)
		.selectAll('g.band')
		.transition()
		.duration(250)
		.attr('opacity', function (d) {
			// @ts-ignore:next-line
			const current = d3.select(this).datum().key;
			return current === item.key ? 1.0 : 0.5;
		});
}

export function onMouseOut(svg) {
	d3.select(svg).selectAll('g.band').transition().duration(250).attr('opacity', 1.0);
}

export function onClear(svg) {
	d3.select(svg).selectAll('g').remove();
}